import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postLTSupportTicket = createApi(`LTSupportTicketSlice`,"POST");

const LTSupportTicketSlice = createSlice({
  name: 'LTSupportTicketSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postLTSupportTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postLTSupportTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postLTSupportTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default LTSupportTicketSlice.reducer;